export default "__VITE_ASSET__cTG$Dqzg__"